import PaymentService from "services/PaymentService";

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getPayments = createAsyncThunk(
  "payments/getAll",
  async (studentFormationName, { rejectWithValue }) => {
    try {
      const response = await PaymentService.getPayments(studentFormationName);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response || "Erreur");
    }
  }
);

export const updatePayment = createAsyncThunk(
  "payments/update",
  async ({ paymentId, newPayment }, { rejectWithValue }) => {
    try {
      const response = await PaymentService.updatePayment({
        paymentId,
        newPayment,
      });
      return response?.data;
    } catch (error) {
      rejectWithValue(error?.reponse?.data?.message || "Erreur");
    }
  }
);
export const pay = createAsyncThunk(
  "payments/pay",
  async ({ paymentId, newPayment }, { rejectWithValue }) => {
    try {
      const response = await PaymentService.pay({
        paymentId,
        newPayment,
      });
      return response?.data;
    } catch (error) {
      rejectWithValue(error?.reponse?.data?.message || "Erreur");
    }
  }
);

export const removeDiscount = createAsyncThunk(
  "payments/removeDiscount",
  async (paymentId, { rejectWithValue }) => {
    try {
      const response = await PaymentService.removeDiscount(paymentId);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Erreur");
    }
  }
);
export const editPaymentHistory = createAsyncThunk(
  "payments/editHistory",
  async ({ paymentId, historyId, data }, { rejectWithValue }) => {
    try {
      const response = await PaymentService.editPaymentHistory({
        paymentId,
        historyId,
        data,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Erreur");
    }
  }
);

export const deletePaymentHistory = createAsyncThunk(
  "payments/deleteHistory",
  async ({ paymentId, historyId }, { rejectWithValue }) => {
    try {
      const response = await PaymentService.deletePaymentHistory({
        paymentId,
        historyId,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Erreur");
    }
  }
);

const initialState = {
  payments: [],
  payment: null,
  loading: false,
  error: null,
};

const paymentSlice = createSlice({
  name: "payments",
  initialState: initialState,
  reducers: {
    setPayments: (state, { payload }) => {
      state.payments = payload;
    },
    setPayment: (state, { payload }) => {
      state.payment = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },

  extraReducers: {
    [getPayments.pending]: (state) => {
      state.loading = true;
    },
    [getPayments.fulfilled]: (state, { payload }) => {
      state.payments = payload.data;
      state.loading = false;
    },

    [getPayments.rejected]: (state) => {
      state.loading = false;
    },

    [updatePayment.pending]: (state) => {
      state.loading = true;
    },
    [updatePayment.fulfilled]: (state, { payload }) => {
      state.payments = state.payments.map(
        (payment) => (payment._id === payload.data._id ? payload.data : payment) // Replace the matching object
      );
      state.loading = false;
    },

    [updatePayment.rejected]: (state) => {
      state.loading = false;
    },

    [editPaymentHistory.pending]: (state) => {
      state.loading = true;
    },
    [editPaymentHistory.fulfilled]: (state, { payload }) => {
      state.payment = payload.data;
      state.loading = false;
    },
    [editPaymentHistory.rejected]: (state) => {
      state.loading = false;
    },
    [deletePaymentHistory.pending]: (state) => {
      state.loading = true;
    },
    [deletePaymentHistory.fulfilled]: (state, { payload }) => {
      state.payment = payload.data;
      state.loading = false;
    },
    [deletePaymentHistory.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { setPayments, setPayment, setLoading, setError } =
  paymentSlice.actions;

export default paymentSlice.reducer;
